/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-16 12:01:15
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-13 20:26:24
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/Components/ProductGridDisplay/index.tsx
 */
import React from 'react';

import _ProductGridDisplay from 'src/components/Modules/ProductGridDisplay';

import ContentGroupHOC from '../HOC';
import DataHOC from 'src/constrains/DraggableModules/Components/HOC/DataProcessHOC';
import { compose } from 'redux';

const ProductGridDisplay = (props) => {
  const {
    staticData,
    dynamicData,
    handleOnItemDelete,

    handleItemOnSort,
    handleOnStaticsChange,

    droppableId,
    handleOnItemDeleteAll,
    handleOnReselect,
    allDisabled,
  } = props || {};

  return (
    <_ProductGridDisplay
      staticData={staticData} //staticData
      products={dynamicData.map((i) => {
        const { productName } = i || {};
        return { ...(i || {}), name: productName };
      })} //
      onItemDelete={handleOnItemDelete} //onItemDelete
      onItemSort={handleItemOnSort} //onItemSort
      onStaticChange={handleOnStaticsChange} //onStaticChange
      onItemDeleteAll={handleOnItemDeleteAll} //onItemDeleteAll
      onItemReselect={handleOnReselect} //onItemReselect
      droppableId={droppableId} //droppableId
      disabled={allDisabled}
    />
  );
};
export default compose(DataHOC, ContentGroupHOC)(ProductGridDisplay);
